import { Badge } from "@/components/ui/badge";

const TONES = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  overdue: "bg-rose-50 text-rose-700 border-rose-200",
  passive: "bg-slate-100 text-slate-600 border-slate-300",
  info: "bg-sky-50 text-sky-700 border-sky-200",
  muted: "bg-slate-50 text-slate-500 border-slate-200",
};

export function StatusBadge({ tone = "info", children, testId, className = "" }) {
  return (
    <Badge
      data-testid={testId}
      variant="outline"
      className={`${TONES[tone] || TONES.info} font-semibold rounded-full px-2.5 py-0.5 ${className}`}
    >
      {children}
    </Badge>
  );
}
